const now = new Date()

const vid1 = {
  name: 'Was bringen mir die verschiedenen Strategien?',
  created: new Date(now.getTime()).setHours(now.getHours() - 24),
  category: 'Academy',
  screenshot: '5.png',
  views: 255,
  votes: 90
}

const vid2 = {
  name: 'Die finCraft Welt als App',
  created: new Date(now.getTime()).setHours(now.getHours() - 17),
  category: 'Academy',
  screenshot: 'Fake_Video-1.jpg',
  views: 210,
  votes: 75
}

const vid3 = {
  name: 'Anlagestrategien (1) Value',
  created: new Date(now.getTime()).setHours(now.getHours() - 14),
  category: 'Investieren',
  screenshot: 'Fake_Video-2.jpg',
  views: 200,
  votes: 60
}

const vid4 = {
  name: 'Anlagestrategien (2) Wachstum',
  created: new Date(now.getTime()).setHours(now.getHours() - 13),
  category: 'Investieren',
  screenshot: 'Fake_Video-3.jpg',
  views: 175,
  votes: 50
}

const vid5 = {
  name: 'DayTrading: Anleitung zum Unglücklich sein',
  created: new Date(now.getTime()).setHours(now.getHours() - 7),
  category: 'Meinung',
  screenshot: 'Fake_Video-4.jpg',
  views: 170,
  votes: 45
}

const vid6 = {
  name: 'Auf der Suche nach Immobilienaktien',
  created: new Date(now.getTime()).setHours(now.getHours() - 6),
  category: 'Investieren',
  screenshot: 'Fake_Video-5.jpg',
  views: 140,
  votes: 40
}

const vid7 = {
  name: 'Die Rolle von Gold im Portfolio',
  created: new Date(now.getTime()).setHours(now.getHours() - 4),
  category: 'Investieren',
  screenshot: 'Fake_Video-6.jpg',
  views: 125,
  votes: 25
}

const vid8 = {
  name: 'Megatrend Cloud',
  created: new Date(now.getTime()).setHours(now.getHours() - 2),
  category: 'Trends',
  screenshot: 'Fake_Video-7.jpg',
  views: 115,
  votes: 20
}

const vid9 = {
  name: 'No Limits? Niemals ohne Handeln!',
  created: new Date(now.getTime()).setHours(now.getHours() - 1),
  category: 'Academy',
  screenshot: 'Fake_Video-8.jpg',
  views: 85,
  votes: 15
}

const vid10 = {
  name: 'ESG Green Investing ?',
  created: now,
  category: 'Trends',
  screenshot: 'Fake_Video-9.jpg',
  views: 10,
  votes: 5
}

export const academyVideos = [
  vid1, vid2, vid3, vid4, vid5, vid6, vid7, vid8, vid9, vid10
]
